import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserContext } from '../../context/UserContext';
import api from '../Api/Api';
import logo from "../../assets/logo.png";
import "./index.scss";
import Spinner from "../../Components/Spinner";
const Login = () => {
  const {user, setUser} = useContext(UserContext)
  const [filial_, setFilial] = useState('01')
  const [usuario, setUsuario] = useState('')
  const [password, setPassword] = useState('')
  const [callback, setCallback] = useState('')
  const [ShowLoading, setShowLoading] = useState(false)
  const navigate = useNavigate();  
  
  function fetchLogin () {
    if(usuario === ''){
        alert("Preencher o campo usuario!")
        return
    }
    if(password === ''){
        alert("Preencher o campo senha!")
        return
    }    
    setTimeout(() => {
        setShowLoading(true)        
        let chave = ''; 
        const userrest = 'RestAPI'
        const passwdrest = 'siga@181'
        const credentials = btoa(`${userrest}:${passwdrest}`); 
        const headers = {
            'Content-Type': 'application/json;charset=UTF-8',
            "Access-Control-Allow-Origin": "*",
            "User-Agent": "PneusBrasil",
            "Accept": "application/json",
            'Authorization': `Basic ${credentials}`
          }         
        api.get('Logar?Usuario=' + usuario + '&Senha=' + password + '&Empresa=01&_Filial='+filial_,{headers})        
            .then(response => {
                chave = response.data.Usuarios[0]['token'];
                if (chave === 'PneusBrasilLogin2024-sim-liberado+o-Vendedor') {
                    setUser({
                        islogin: true,
                        name: response.data.Usuarios[0]['NomeVendedor'],
                        codigo: response.data.Usuarios[0]['Vendedor'],
                        tipo: response.data.Usuarios[0]['tipo'],
                        filial: filial_,
                        codusuario: response.data.Usuarios[0]['codusuario'],
                        userRest: 'RestAPI',
                        passRest: 'siga@181',
                        token: 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6InBKd3RQdWJsaWNLZXlGb3IyNTYifQ.eyJpc3MiOiJUT1RWUy1BRFZQTC1GV0pXVCIsInN1YiI6IlJlc3RBUEkiLCJpYXQiOjE3NTk3NzI0OTIsInVzZXJpZCI6IjAwMDE1MiIsImV4cCI6MTc1OTc3NjA5MiwiZW52SWQiOiJQVEVTVEUifQ.AtjK9pJaSAdnV86t3TdxnFbPnii2xOqxd5oIQayXg9tUOF6QdKmsl8xRL7VBZwaOsIOJpkhEx09AY6S1841CtUNA99zg5fKhq2SjTOf3BsMw9-2mTY1VqZiQZA3RavtdAD-zxBgX9NlaAY5iAZ7guU_L43I1isy7J3x7LLref8V-Mr1_kaOMqi2G68j7BY4CO-P-j_7bwJAvVcfV3mA7LXcnIXvGyo_QaaLZUDw6q9M6S41kMcY7riCS3Dfjk7UkQubA3WKfTBL-iJHwMTij6ci3egZZrtS6HRtV19t3UCs_Ry6k9jOth9-rf9ISgRcnTC9XTFrpVDlNxE4TYW7syg'                        
                    })
                        setShowLoading(false) 
                        setCallback('')
                    } else {    
                        setShowLoading(false)              
                        return alert('Usuario ou senha invalido!');
                    }                 
                })
            .catch((error) => {
                setShowLoading(false)
                alert("Ocorreu um erro ao buscar as informações!");
                return setCallback('https://198.0.1.201:8897/rest/');
            });
    }, 10);   
  }
  useEffect(() =>{
  
        if (user.islogin){
            navigate('/Home')
        }

  })
    
  return (
    <div className='tbody'>
    <div className="container-lg">
            <div className='logo'>
                <img
                    src={logo}
                    width="150"
                    className="logo-info"
                    alt="Heringer"
                    />                
            </div> 
        <div id="formlogin">
            <h1>Login do Sistema</h1>           
            {/* <form name="loginForm"> */}

            <div className="form">
                <div className="field">
                    <label htmlFor="Filial">Filial</label>                    
                    <input 
                        //value={'ismael'}
                        type="text" 
                        name="filial" 
                        onChange={e => setFilial(e.target.value)} 
                        placeholder="Digite a sua filial. Ex: 01" 
                        />
                </div>

                <div className="field">
                    <label htmlFor="login">Usuario</label>                    
                    <input 
                        //value={'ismael'}
                        type="text" 
                        name="login" 
                        onChange={e => setUsuario(e.target.value)} 
                        placeholder="Digite o seu usuario" 
                        />
                </div>

                <div className="field">
                    <label htmlFor="password">Senha</label>
                    <input 
                    //value={'123'}
                    type="password" 
                    name="password" 
                    onChange={e => setPassword(e.target.value)} 
                    placeholder="Digite sua Senha" 
                    />
                </div>

                <div className="actions">
                <button className="primary" onClick={() => fetchLogin()}>Entrar</button>
                </div>
                
            </div>
            {/* { isLoginPending && <div>Por favor aguarde...</div> } */}
            {/* { isLoggedIn && <div>Success.</div> } */}
            {/* { loginError && <div>{loginError.message}</div> } */}
            {/* </form> */}
            <div>
                {callback !== ''?(<><button onClick={() => setCallback('')} className='mt-16'><Link to={'https://198.0.1.201:8199/rest/'} target="_blank">Testar conexão com banco de dados!</Link></button></>):('')}
            </div>
        </div>
        <Spinner isLoading={ShowLoading} />
    </div>
    </div>
  )
}


export default Login;